import { inject, injectable } from "@launchtray/tsyringe-async";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { INetworkClient } from "by/gamefactory/cityversetycoon/networking/INetworkClient";

@injectable()
export class RemoveBuildingModel {
    private readonly networkClient: INetworkClient;
    private readonly logger: ILogger;

    public constructor(
        @inject("INetworkClient") networkClient: INetworkClient,
        @inject("ILogger") logger: ILogger
    ) {
        this.networkClient = networkClient;
        this.logger = logger;
    }

    public async removeBuildingFromMarketplace(mpBuildingId: string): Promise<boolean> {
        try {
            await this.networkClient.deleteBuildingFromMarketplace(mpBuildingId);
            return true;
        } catch (e: unknown) {
            this.logger.error(e);
            return false;
        }
    }
}